export const LOGO_URL =
  "https://customer-assets-agu9un31.emergentagent.net/job_secured-minerals-co/artifacts/a50385e984cb69ee_Logo_Ore_Source-removebg-preview.png";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const IMAGES = {
  hero: "https://images.pexels.com/photos/31721779/pexels-photo-31721779.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  cathodesWarehouse:
    "https://images.unsplash.com/photo-1753771145085-d71e89c23092?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxlbGVjdHJvbHl0aWMlMjBjb3BwZXIlMjBjYXRob2RlJTIwc2hlZXRzfGVufDB8fHx8MTc5MjY1ODMwMXww&ixlib=rb-4.1.0&q=85",
  cathodesBundles:
    "https://images.unsplash.com/photo-1711012604128-8339024a3e12?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHw0fHxtaW5pbmclMjBleGNhdmF0b3IlMjBoZWF2eSUyMGVxdWlwbWVudHxlbnwwfHx8fDE3OTI2NTc2MTR8MA&ixlib=rb-4.1.0&q=85",
  copperOre:
    "https://images.unsplash.com/photo-1764022276404-85682f38ae35?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxtYWxhY2hpdGUlMjByYXclMjBtaW5lcmFsJTIwcm9jayUyMGNvcHBlciUyMG9yZXxlbnwwfHx8fDE3OTI2NTc2MTl8MA&ixlib=rb-4.1.0&q=85",
  sulphur:
    "https://images.unsplash.com/photo-1792299407514-bcd8a4c4b50c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwzfHxzdWxwaHVyJTIweWVsbG93JTIwbWluZXJhbCUyMHBpbGV8ZW58MHx8fHwxNzkyNjU3NjE0fDA&ixlib=rb-4.1.0&q=85",
  goldDore:
    "https://images.unsplash.com/photo-1610375461369-d613b564f4c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxnb2xkJTIwaW5nb3QlMjBiYXIlMjBtZXRhbHxlbnwwfHx8fDE3OTI2NTc2MTR8MA&ixlib=rb-4.1.0&q=85",
  lithium:
    "https://images.unsplash.com/photo-1584715642381-6f1c4b452b1c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxsaXRoaXVtJTIwcm9jayUyMG1pbmVyYWwlMjBvcmV8ZW58MHx8fHwxNzkyNjU3NjE0fDA&ixlib=rb-4.1.0&q=85",
  operations:
    "https://images.pexels.com/photos/19926733/pexels-photo-19926733.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  shipping:
    "https://images.unsplash.com/photo-1769144256207-bc4bb75b29db?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxjb250YWluZXIlMjBzaGlwJTIwY2FyZ28lMjBwb3J0JTIwbG9hZGluZyUyMGRvY2slMjB3YXJlaG91c2UlMjB3b3JrZXJzJTIwc2FmZXR5JTIwaGVsbWV0JTIwbG9naXN0aWNzfGVufDB8fHx8MTc5MjY1NzYxMHww&ixlib=rb-4.1.0&q=85",
};

export const COMMODITIES = [
  "Copper Cathode — Grade A",
  "Copper Concentrate & Ore",
  "Precious Gold (Dore & Alluvial)",
  "Lithium Ore (Spodumene / Lepidolite)",
  "Sulphur Granulars",
];

export const COMMODITIES_FR = [
  "Cathode de Cuivre — Grade A",
  "Concentré & Minerai de Cuivre",
  "Or Précieux (Doré & Alluvial)",
  "Minerai de Lithium (Spodumène / Lépidolite)",
  "Granulés de Soufre",
];

export const PAYMENT_INSTRUMENTS = ["DLC MT700", "SBLC MT760", "TT MT103"];

export const INCOTERMS = ["CFR — Cost & Freight", "CIF — Cost, Insurance & Freight"];

export const MARQUEE_ITEMS = [
  "LME GRADE A COPPER CATHODES",
  "DRC MINING CONCESSIONS",
  "ALLUVIAL GOLD DORE",
  "SPODUMENE LITHIUM ORE",
  "SULPHUR GRANULARS",
  "ISO & KYC CERTIFIED",
  "TIER-1 GLOBAL LOGISTICS",
];
